import State from './State';

/**
 * Mutations are a synchronous way of modifying state. They are generally
 * called through Actions. It's best to think of them as setters.
 *
 * @see https://vuex.vuejs.org/guide/mutations.html
 *
 * @class Mutations
 * @package Store
 * @project ChalkySticks App
 */
const mutations = {
	/**
	 * Clear the pending match configuration.
	 *
	 * @param State state
	 * @return void
	 */
	clearMatchConfig(state: typeof State): void {
		state.matchConfig = null;
	},

	/**
	 * @param State state
	 * @return void
	 */
	setLastOpened(state: typeof State): void {
		state.lastOpened = Date.now();
	},

	/**
	 * Store a match configuration for the Play page to consume.
	 *
	 * @param State state
	 * @param Trainer.IMatchConfig payload
	 * @return void
	 */
	setMatchConfig(state: typeof State, payload: Trainer.IMatchConfig): void {
		state.matchConfig = payload;
	},

	/**
	 * @param State state
	 * @return void
	 */
	setOrientation(state: typeof State): void {
		state.isLandscape = window.innerWidth > window.innerHeight;
		state.hasBeenLandscape = state.hasBeenLandscape || state.isLandscape;
	},

	/**
	 * @param State state
	 * @param any payload
	 * @return void
	 */
	setQueryParameters(state: typeof State, payload: any): void {
		state.queryParameters = payload;
	},

	/**
	 * Set the visibility of the primary context menu
	 *
	 * @param State state
	 * @param boolean payload
	 * @return void
	 */
	setShowPrimaryContextMenu(state: typeof State, payload: boolean): void {
		state.showPrimaryContextMenu = payload;
	},

	/**
	 * @param State state
	 * @param boolean payload
	 * @return void
	 */
	setShowingKeyboard(state: typeof State, payload: boolean): void {
		state.showingKeyboard = payload;
	},
};

export default mutations;
